/** Expand all has nothing to do when no row is open and none can open; Collapse all always has work while one is open. */
export function isExpandAllDisabled({
  anyRowExpanded,
  hasExpandableRows,
}: Readonly<{ anyRowExpanded: boolean; hasExpandableRows: boolean }>): boolean {
  return !anyRowExpanded && !hasExpandableRows;
}
